import styled from "@emotion/styled";
import { Switch } from "@rebass/forms";

const SwitchToggle = styled(Switch)``;

SwitchToggle.defaultProps = {};

export default SwitchToggle;
